export default {
  default: () => import("/opt/buildhome/repo/src/layouts/default.vue").then(m => m.default || m),
  "default-footer": () => import("/opt/buildhome/repo/src/layouts/default/DefaultFooter.vue").then(m => m.default || m),
  "default-header": () => import("/opt/buildhome/repo/src/layouts/default/DefaultHeader.vue").then(m => m.default || m),
  printable: () => import("/opt/buildhome/repo/src/layouts/printable.vue").then(m => m.default || m)
}